// 字典
import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
    success: any,
    fail: any,
}
// 获取组织机构树
const getOrganizationManageTree = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETOrganizationManageTree(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
// 新增组织
const postOrganizationManageAdd = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTOrganizationManageAdd(params);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
// 修改组织
const postOrganizationManageUpdate = (params: any): Promise<HandleResInterface> => {
	return new Promise(async (resolve) => {
			const res = await request.POSTOrganizationManageUpdate(params);
			const result = handleRes(res, {
					failMes: res.msg,
			});
			resolve(result);
	});
};
// 修改组织
const deleteOrganizationManageDelete = (params: any): Promise<HandleResInterface> => {
	return new Promise(async (resolve) => {
			const res = await request.DELETEOrganizationManageDelete(params);
			const result = handleRes(res, {
					failMes: res.msg,
			});
			resolve(result);
	});
};

export {
	getOrganizationManageTree,
	postOrganizationManageAdd,
	postOrganizationManageUpdate,
	deleteOrganizationManageDelete
};
